
<template>
    <div class="row justify-content-center error-ct hcol-9 pt-5">
        <div class="col-9 text-center align-items-center pt-5">
            <div class="error-icon mb-3"><span class="material-icons">error_outline</span></div>
            <h1 class="text-yellow">{{$t('out_of_order_title')}}</h1>
            <h3>{{$t('out_of_order_content')}}</h3>
        </div>
    </div>
</template>

<script>
import HeaderRow from '@/components/Header';
export default {
  components: {
      HeaderRow
  },
  props: [
    "language"
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
</style>